<template>
  <div>
    <div class="right-title">
      <span>机构职位详情</span>
      <div class="conten-btn-box" v-show="istrue">
        <el-button class="mtl" type="success" @click="shenhe(1)" size="medium">审核通过</el-button>
        <el-button class="mtl" type="danger" @click="shenhe(2)" size="medium">审核不通过</el-button>
        <!--        <el-button class="mtl" plain size="medium">设置机构为不信任</el-button>-->
      </div>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="waiBox">
        <p class="diz">招聘标题：<span class="s1">{{ tableData.jobs_name }}</span></p>
        <p class="diz">所属机构：<span>{{ tableData.organization_name }}</span></p>
        <p class="diz">发布时间：<span>{{ tableData.create_time }}</span></p>
        <p class="diz">用工性质：<span>{{ tableData.nature | title }}</span></p>
        <p class="diz">工作地址：<span>{{ tableData.district_cn }} {{tableData.district}}</span></p>
        <p class="diz">招聘人数：<span>{{ tableData.amount }}人</span></p>
        <p class="diz">工作年限：<span>{{ tableData.experience_cn }}</span></p>
        <p class="diz">学历要求：<span>{{ tableData.education_cn }}</span></p>
        <div class="diz">岗位描述：<br><br><br>
          <div class="ql-editor" v-html="tableData.contents"></div>
        </div>
        <p class="diz" v-if="tableData.video">视频链接：<a :href="tableData.video" target="_blank"
                                                      style="margin-left:20px;padding: 5px 20px;background: #00a2ea;color: #fff;border-radius: 5px;">点击查看</a>
        </p>
        <p class="diz" v-if="tableData.minwage === -1">薪资待遇：<span>面议</span></p>
        <p class="diz" v-else-if="tableData.minwage === 0 && tableData.maxwage === 0">薪资待遇：<span>30K以上</span></p>
        <p class="diz" v-else>薪资待遇：<span>{{ tableData.minwage }}K-{{ tableData.maxwage }}K/月</span> * {{ tableData.salary_month }} 个月</p>
        <p class="diz">福利待遇：<span class="s2" v-for="(item,index) in tableData.tag_cn" :key="index">{{ item }}</span></p>
        <p class="diz">熟人推荐模式：
          <span style="color: #00a2ea" v-if="tableData.push_type === 1">使用 赏金：{{ tableData.push_type_money }}元</span>
          <span v-else>未使用</span>
        </p>
        <p class="diz">备注：<br><br><br><span>{{ tableData.mark }}</span></p>

      </div>
      <resumeList v-show="!istrue"/>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
import footerBox from '../components/rightBottom'
import resumeList from "@/components/resumeList";
export default {
  name: "jgZhiw",
  data() {
    return {
      radio: '1',
      id: '',
      istrue: false,
      tableData: {}
    };
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {
    // this.$emit('setType', 3, 0)
    //  职位ID
    this.id = this.$route.params.id
    this.istrue = this.$route.query.istrue

    this.zhiWxq()
  },
  methods: {
    // 职位详情
    zhiWxq() {
      this.$api.apiContent.jgZhiwXqing({
        id: this.id,
        admin_id: this.user.id
      }).then(res => {
        this.tableData = res.data
        this.tableData.create_time = this.$tools.ZHDate(new Date(res.data.create_time * 1000), 3)
        this.tableData.tag_cn = this.tableData.tag_cn.substr(0, this.tableData.tag_cn.length - 1)
        this.tableData.tag_cn = this.tableData.tag_cn.substr(1, this.tableData.tag_cn.length - 1)
        this.tableData.tag_cn = this.tableData.tag_cn.split(",")

      }).catch(res => {
        this.$message.error(res.info);
      })
    },
    //  审核 通不通过
    shenhe(num) {
      let messg = ""
      if (num === 1) {
        messg = "此操作将审核通过, 是否继续?"
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.jgZhiwXqingShen({
            id: this.id,
            admin_id: this.user.id,
            audit: num
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.goBack()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {

        });
      } else {
        this.$prompt('请填写拒绝理由', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({value}) => {
          this.$api.apiContent.jgZhiwXqingShen({
            id: this.id,
            admin_id: this.user.id,
            audit: num,
            delContent: value
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.goBack()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {

        });
      }
    },
    //  返回上一页
    goBack() {
      this.$tools.goBack()
    },
  },
  filters: {
    title(val) {
      let _str = ""
      switch (val) {
        case 1 :
          _str = "全职"
          break
        case 2 :
          _str = "实习"
          break
        case 3 :
          _str = "兼职"
          break
      }
      return _str
    },

  },
  watch: {},
  components: {
    footerBox,
    resumeList
  }

}
</script>

<style scoped lang="scss">
.right-title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .conten-btn-box {
    .mtl {
      height: 30px;
      padding: 0 15px;
    }
  }
}

/*.mtl {*/
/*  margin-top: 5px;*/
/*  margin-left: 10px;*/
/*}*/
.waiBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-left: 40px;
  margin-top: 40px;

  p {
    width: 50%;
  }

  div {
    width: 50%;
  }

  .tit {
    font-size: 14px;
    margin-top: 40px;

    span {
      /*font-size: 26px;*/
      /*font-weight: bold;*/
      margin-left: 10px;
    }

    .s1 {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .xingz {
    font-size: 14px;
    margin-top: 40px;

    span {
      margin-right: 20px;
    }

  }

  .diz {
    font-size: 14px;
    margin-top: 40px;

    span {
      margin-left: 20px;
    }

    .s1 {
      font-size: 18px;
      font-weight: bold;
    }

    .s2 {
      width: 40px;
      line-height: 25px;
      margin-left: 20px;
    }
  }
}

.jies {
  width: 100%;

  padding-top: 15px;
  overflow: hidden;
  margin-top: 180px;

  img {
    width: 100%;
  }

  .j-l {
    width: 400px;
    float: left;
    margin-left: 40px;

    .p1 {
      font-size: 20px;
      font-weight: bold;
      margin-top: 20px;
      margin-bottom: 30px;
    }

    .p2 {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .j-r {
    width: 200px;
    height: 180px;
    float: right;
    margin-right: 40px;

    .img {
      width: 120px;
      height: 120px;
      margin-left: 40px;
      background-color: #333333;
    }

    .p3, .p4 {
      width: 100%;
      line-height: 30px;
      font-size: 14px;
      text-align: center;
    }
  }
}

.aniu {
  position: absolute;
  top: 20px;
  right: 10px;
}
</style>
